import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_VIDEO_MEETINGS } from '@/api/endpoints';
import { VIDEO_MEETINGS_QUERY_KEY } from '@/api/queryKeys';
import { toVideoMeetings } from '@/pages/Mail/videoMeetings';
import type { VideoMeeting, VideoMeetingResponse } from '@/types/video';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useVideoMeetings = (isEnabled: boolean) =>
  useQuery<VideoMeetingResponse[], Error, VideoMeeting[]>({
    queryKey: VIDEO_MEETINGS_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<VideoMeetingResponse[]>(API_VIDEO_MEETINGS)
        .then(unwrapAxiosResponse),
    select: toVideoMeetings,
    enabled: isEnabled,
  });
